import { render, staticRenderFns } from "./Payments_tab.vue?vue&type=template&id=739e2f95&"
import script from "./Payments_tab.vue?vue&type=script&lang=js&"
export * from "./Payments_tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports